/**
 * Serviço para integração com a API da IA
 */

// Função para gerar ID alfanumérico aleatório
export const generateRandomId = (length = 16) => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

// Função para integrar com a API de IA
export const sendToAIEndpoint = async (message, conversationId, cliente) => {
  try {
    // Endpoint da API
    const apiUrl =
      process.env.VUE_APP_IA_BASE_URL ||
      "https://multpex-ia.prod.multpex.com.br/perguntar";

    // Parâmetros da requisição
    const requestData = {
      tenant: cliente, // Usando o slug do cliente
      conversation_id: conversationId,
      pergunta: message,
    };

    // Configuração da requisição
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ACCESS_KEY: process.env.VUE_APP_IA_AK || "AaTcXYlZzJVkcySuAGnk",
      },
      body: JSON.stringify(requestData),
    };

    // Fazendo a requisição para a API
    const response = await fetch(apiUrl, requestOptions);

    if (!response.ok) {
      throw new Error(`Erro na requisição: ${response.status}`);
    }

    const data = await response.json();
    let apiResponseContent = data.resposta;
    let queryGenerated = data.query || null; // Captura a query gerada pela IA

    // Attempt to parse if apiResponseContent is a string
    if (typeof apiResponseContent === "string") {
      try {
        const parsedContent = JSON.parse(apiResponseContent);
        // Check if the parsed content could be a structured table object or other JSON structures
        if (typeof parsedContent === "object" && parsedContent !== null) {
          apiResponseContent = parsedContent; // Use the parsed object/array
        }
        // If parsedContent is a primitive (e.g. a string that was doubly encoded like "\\"hello\\""),
        // JSON.parse would return the primitive. In that case, apiResponseContent would become e.g. "hello".
        // This is generally fine as it will be handled by later logic.
      } catch (e) {
        // Parsing failed, apiResponseContent remains the original string.
        // This will be treated as a plain string message.
      }
    }

    // Now, process apiResponseContent (which is original data.resposta or a parsed version)
    // Check if it's already the {isTable: true, data: [...]} structure
    if (
      typeof apiResponseContent === "object" &&
      apiResponseContent !== null &&
      apiResponseContent.isTable === true &&
      Array.isArray(apiResponseContent.data)
    ) {
      return { content: apiResponseContent, query: queryGenerated };
    } else if (
      // Check if it's an array of data objects that needs wrapping
      Array.isArray(apiResponseContent) &&
      apiResponseContent.length > 0 &&
      typeof apiResponseContent[0] === "object"
    ) {
      return {
        content: {
          isTable: true,
          data: apiResponseContent,
        },
        query: queryGenerated,
      };
    } else if (Array.isArray(apiResponseContent)) {
      // It's some other kind of array (e.g., array of strings), stringify it
      return {
        content: JSON.stringify(apiResponseContent, null, 2),
        query: queryGenerated,
      };
    }

    // Otherwise (e.g., it's a simple string, number, or an unhandled object)
    return { content: apiResponseContent, query: queryGenerated };
  } catch (error) {
    console.error("Erro ao enviar mensagem para a IA:", error);
    return {
      content:
        "Desculpe, ocorreu um erro ao processar sua solicitação. Por favor, tente novamente mais tarde.",
      query: null,
    };
  }
};

// Função para enviar avaliação da resposta da IA
export const sendRatingToAPI = async (ratingData) => {
  try {
    // Endpoint para enviar a avaliação
    const ratingApiUrl =
      process.env.VUE_APP_IA_RATING_URL ||
      "https://n8n.devops.multpex.com.br/webhook/e6ee281c-4422-4308-ac7a-df8a774b09bd";

    // Configuração da requisição
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ACCESS_KEY: process.env.VUE_APP_IA_AK || "AaTcXYlZzJVkcySuAGnk",
      },
      body: JSON.stringify(ratingData),
    };

    // Enviar avaliação
    const response = await fetch(ratingApiUrl, requestOptions);

    if (!response.ok) {
      throw new Error(`Erro ao enviar avaliação: ${response.status}`);
    }

    return true;
  } catch (error) {
    console.error("Erro ao enviar avaliação:", error);
    throw error;
  }
};

// Função para enviar feedback
export const sendFeedbackToAPI = async (feedbackData) => {
  try {
    // Endpoint para enviar feedback
    const feedbackApiUrl =
      process.env.VUE_APP_FEEDBACK_URL ||
      "https://n8n.devops.multpex.com.br/webhook/5780e70b-98ea-4ca7-a281-a0d8da270e0d";

    // Configuração da requisição
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ACCESS_KEY: process.env.VUE_APP_IA_AK || "AaTcXYlZzJVkcySuAGnk",
      },
      body: JSON.stringify(feedbackData),
    };

    // Enviar feedback
    const response = await fetch(feedbackApiUrl, requestOptions);

    if (!response.ok) {
      throw new Error(`Erro ao enviar feedback: ${response.status}`);
    }

    return true;
  } catch (error) {
    console.error("Erro ao enviar feedback:", error);
    throw error;
  }
};
